import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {  login } from '../utils/api/request';
import {useHistory} from "react-router-dom";
import './login.scss';
import Grid from '@material-ui/core/Grid';
const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
}));
type UserInfo = {
    userName: string
    password: string
    sign: number
    loginCardStatus:number
    returnError:string
}
const defaultState: UserInfo = {
    userName: '',
    password: '',
    sign:1,
    loginCardStatus:0,
    returnError:''
}
//登录
function Login() {
    const [user, setUserInfo] =  useState<UserInfo>(defaultState);


    const history = useHistory();
    const classes = useStyles();
    const handleSubmit = () => {
        //校验输入值
        // globalStore.showLoading();
        const payload = {
            userName: user.userName,
            password: user.password,
            sign:user.sign
        }
        login(payload).then((success: any) => {
            // 登录成功后存储token并跳转到home页面 , 不用存储过期时间 ,  服务端过期以后 , 拦截器无脑跳登录页面
            if(success.status==500){
                setUserInfo({
                    ...user,
                    returnError:'账号或者密码错误!'
                })

            }else{
                localStorage.setItem('online-token',success.data);
                history.push('/classroom/class-list')
            }

        }, (error: any) => {
        }).finally(() => {
            // globalStore.stopLoading();
        })
    }

    const changeStatus=(sign:number)=>{
        setUserInfo({
            ...user,
            sign:sign
        })
    }
    const changeLoginCardStatus=(sign:number)=>{
        setUserInfo({
            ...user,
            userName: '',
            password: '',
            loginCardStatus:sign,
            returnError:''
        })
    }

    return (


        <div>
            <div className='login-root' style={{minWidth:'960px'}} >
                {user.loginCardStatus==1? <div  className='login-mask' onClick={() => changeLoginCardStatus(0)}></div>:null}
                <div className='login-image'>
                    <a href="https://cloud.magaoedu.com" target="_blank"><div className='login-icon'> </div></a>
                    <img src="https://data.magaoedu.com/magao-login-background-1.jpg"/>
                    <img src="https://data.magaoedu.com/magao-login-background-2.jpg"/>
                    <img src="https://data.magaoedu.com/magao-login-background-3.jpg"/>
                    <div className='login-live-some'>
                        <div className='login-live-title'> 码高云听课堂 </div>
                        <div className='login-live-desc'> 轻量级web端，无需下载安装，专为编程教育设计 </div>
                        <div className='login-live-now' onClick={() => changeLoginCardStatus(1)}></div>
                    </div>
                    <div  className='login-go-down'>
                    </div>

                    {user.loginCardStatus==1? <div className='login-card'>
                        <div className='change-role'>
                            <div className={`login-student ${user.sign==1?'login-role-changed':''}`} onClick={() => changeStatus(1)}>
                                <span className='login-avatar-image login-avatar-image-student'></span>
                                <span>学生</span>
                            </div>
                            <div className={`login-teacher ${user.sign==0?'login-role-changed':''}`}  onClick={() => changeStatus(0)}>
                                <span className='login-avatar-image login-avatar-image-teacher' ></span>
                                <span>老师</span>
                            </div>
                        </div>
                        <div className={`change-turn-icon ${user.sign==1?'change-turn-icon-student':'change-turn-icon-teacher'}`}></div>
                        <div className='login-input'>
                            <Grid
                                container
                                direction="column"
                                justify="space-around"
                                alignItems="center"
                                style ={{height:'300px'}}
                            >
                                <div className='login-input-title'>码高云听课堂</div>
                                {/*<form  noValidate autoComplete="true">*/}
                                <div style={{width:'328px'}}>
                                    <TextField style={{fontSize:'656px'}} fullWidth id="standard-basic" label="账号" variant="outlined" onChange={(event:any)=>{
                                        setUserInfo({
                                            ...user,
                                            userName: event.target.value,
                                            returnError:''
                                        });
                                    }}/>
                                </div>
                                <div style={{width:'328px'}}>
                                    <TextField fullWidth
                                               id="standard-password-input"
                                               label="密码"
                                               type="password"
                                               autoComplete="current-password"
                                               variant="outlined"
                                               helperText={user.returnError}
                                               onChange={(event:any)=>{
                                                   setUserInfo({
                                                       ...user,
                                                       password: event.target.value,
                                                       returnError:''
                                                   });
                                               }}/>
                                </div>
                                {/*</form>*/}
                                <div className='login-button' onClick={handleSubmit}>登录</div>
                                <div className='login-support'>如需技术支持，请加入QQ群：929110302</div>
                            </Grid>

                        </div>
                    </div>:null}

                </div>
                <div className='login-tail'>
                    <div  className='login-table-title'>
                        <div className='login-table-title-usual'>常用软件</div>
                        <div className='login-table-title-plat'>平台监测</div>
                    </div>
                    <div  className='login-table-table'>
                        <div id="table_wrap">
                            <table className="table"  cellSpacing="0" cellPadding="0">
                                <thead className="table_head">
                                <tr>
                                    <th></th>
                                    <th>Windows计算机需求</th>
                                    <th>Mac计算机需求</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>CPU</td>
                                    <td>Intel 酷睿i3或更快的处理器</td>
                                    <td>Intel 酷睿M或更快的处理器</td>
                                </tr>
                                <tr>
                                    <td>操作系统</td>
                                    <td>微软Windows 7操作系统或更高的版本</td>
                                    <td>MacOS 10.10或更高的版本</td>
                                </tr>
                                <tr>
                                    <td>内存</td>
                                    <td>4G以上的内存</td>
                                    <td>8G以上的内存</td>
                                </tr>
                                <tr>
                                    <td>屏幕分辨率</td>
                                    <td>至少1280*720的分辨率的显示器
                                        (教师推荐使用两个显示器)
                                    </td>
                                    <td>至少1280*720的分辨率的显示器
                                        (教师推荐使用两个显示器)
                                    </td>
                                </tr>
                                <tr>
                                    <td>声音设备</td>
                                    <td>带麦克风功能的头戴式/耳塞式耳机
                                    </td>
                                    <td>带麦克风功能的头戴式/耳塞式耳机
                                    </td>
                                </tr>
                                <tr>
                                    <td>摄像头设备</td>
                                    <td>笔记本自带或者外接摄像头(罗技等)
                                    </td>
                                    <td>笔记本自带或者外接摄像头(罗技等)
                                    </td>
                                </tr>
                                <tr>
                                    <td>软件</td>
                                    <td>推荐使用Chrome浏览器
                                        备用：Firefox、360浏览器
                                    </td>
                                    <td>推荐使用Chrome浏览器
                                        备用：Firefox、Safari
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                    </div>
                    </div>
                    <div className='login-table-explain'>
                        <span className='login-table-warning'></span>
                        <span className='login-table-note'>为确保上课软件能正常运行，保证上课的通讯品质，计算机建议需要
                            满足以上最低系统要求。建议以有线宽带连接网络-网络宽带需求为光纤网络(如20M/2560Kb) 。尽可能避免使用移动网络或者无线网络。</span>
                    </div>

                    <div className='login-footer'>
                        <p>
                            <a href="https://crm.magaoedu.com/">码高天眼系统</a>|
                            <a href="https://cloud.magaoedu.com/">码高问道平台</a>|
                            <a href="#">码高云听课堂</a>
                        </p>
                        <a href="http://beian.miit.gov.cn" target="_blank"><span>Copyright@2015-2020&nbsp;&nbsp;&nbsp;&nbsp;备案号：京ICP备17070826号-6</span></ a>
                    </div>
                    </div>
            </div>

        </div>
    );
}

export default React.memo(Login);



